import React, { Component } from "react";
import Section from "./components/Section";
import Header from "./components/Header";
import Splash from "./components/Splash";
import ChampionDescription from "./components/ChampionDescription";
import AbilitySpread from "./components/AbilitySpread";
import ImageText from "./components/ImageText";
import Footer from "./components/Footer";
import ModalVideo from "react-modal-video";

import { init } from "./misc/lightning";

import LazyLoad from "react-lazyload";
import LoadingScreen from "react-loading-screen";
import "./App.css";

import { abilities } from "./misc/abilities.js";

class App extends Component {
  imageLoadCount = 0;

  state = {
    dragonlord: "arena",
    poloma: "royale",
    lucie: "royale",
    loading: true,
    modalShown: false
  };
  toggleModal = () => this.setState({ modalShown: !this.state.modalShown });

  toggleAbilities = champion => () =>
    this.setState({
      [champion]: this.state[champion] === "arena" ? "royale" : "arena"
    });

  componentDidMount() {}

  handleImageLoad = () => {
    this.imageLoadCount++;
    if (this.imageLoadCount >= 2) {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="rgb(19, 40, 73)"
        spinnerColor="#9ee5f8"
        textColor="white"
        logoSrc={
          "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/BattleriteWinterEventYuletideLogo-min.png"
        }
        text="Loading..."
      >
        <div className="App">
          <div className="snow" />

          <Header
            refs={this.refs}
            image={
              "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/winter_patch_web_header-min.png"
            }
            style={{ width: "100%" }}
            text3="COMING DECEMBER 12TH"
            handleImageLoad={this.handleImageLoad}
          />
          <img
            draggable={false}
            src={
              "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/sectionDivider_general2.jpg"
            }
            alt="divider"
            width="100%"
          />
          <div className="inner_section" ref="dman">
            <canvas id="canvas" />
            <Splash
              handleImageLoad={() => {
                init();
                this.handleImageLoad();
              }}
              video={{
                id: "byydanAOTAo"
              }}
              intro="new champion"
              name="Shen Rao"
              title="Tempest of the East"
              style={{ maxWidth: "1139px" }}
            />
            <Section
              image={
                "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/section3_background_fix2.png"
              }
              style={{ width: "100%", height: "100%" }}
            >
              <ChampionDescription
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/DragonLordPortrait-min.jpg"
                }
                text="Shen Rao was once The Dragon of Storms, revered as a deity for his majesty and power. In his arrogance, he defied the dark powers of the Void but he was defeated and sealed within a human body, reduced to a fraction of his former strength. In battle he utilizes remnants of his dormant powers, raining down lightning and engulfing his enemies in violent thunderstorms."
              />
            </Section>
            <AbilitySpread
              toggle
              image={
                "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/section4_background_fix2.png"
              }
              champion="dragonlord"
              abilities={abilities["dragonlord"][this.state["dragonlord"]]}
              toggleGame={this.toggleAbilities("dragonlord")}
            />
          </div>

          <div className="inner_section">
            <img
              draggable={false}
              src={
                "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/Line%20divider.png"
              }
              alt="divider"
              width="100%"
            />
            <h3 className="event_title">YULETIDE WINTER EVENT</h3>
            <LazyLoad height={400} offset={400}>
              <Section
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/winter_event_header-min.png"
                }
                style={{ width: "100%" }}
              >
                <div className="consumables">
                  <div>
                    <div>
                      <div className="playButton" onClick={this.toggleModal}>
                        <svg
                          version="1.1"
                          id="play"
                          x="0px"
                          y="0px"
                          height="89px"
                          width="89px"
                          viewBox="0 0 100 100"
                          enableBackground="new 0 0 100 100"
                        >
                          <path
                            className="stroke-solid"
                            fill="none"
                            stroke="white"
                            d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
    C97.3,23.7,75.7,2.3,49.9,2.5"
                          />
                          <path
                            className="icon"
                            fill="white"
                            d="M38,69c-1,0.5-1.8,0-1.8-1.1V32.1c0-1.1,0.8-1.6,1.8-1.1l34,18c1,0.5,1,1.4,0,1.9L38,69z"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>Winter Event</h3>
                    <p>
                      It’s that time of the year to cozy up with hot chocolate
                      by the fire and spend time with the friends and family you
                      love. It’s Yuletide in the Battlerite world!
                    </p>
                  </div>
                </div>
              </Section>
            </LazyLoad>

            <LazyLoad height={400} offset={400}>
              <Section
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/winter_goblin_b4.png"
                }
                style={{ width: "100%" }}
              >
                <div className="goblinBlock">
                  <h3>Winter Goblins</h3>
                  <p>New goblins with a bags full of goodies have arrived!</p>
                  <p>
                    Find and defeat Winter Goblins to pick up event-exclusive
                    consumables!
                  </p>
                </div>
              </Section>
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <Section
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/hungry_snowball_glow.png"
                }
                style={{ width: "100%" }}
              >
                <div className="mooseBlock">
                  <h3>NEW EVENT CONSUMABLES</h3>
                  <p>
                    Fantastic new consumables have appeared on Talon Island,
                    waiting just for you. Keep an eye out for the snowball
                    fights, transform into a hungry hungry snowman, and charge
                    into battle with the Raging Moose Mask!
                  </p>
                </div>
              </Section>
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <ImageText
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/julbord_glow-min.png"
                title="Winter Feast"
                orientation="rightleft"
                description="Prepare a winter feast for everyone to enjoy, just make sure you don’t eat too much food, you might end up in a turkey coma!"
              />

              <img
                draggable={false}
                src={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/Line%20divider.png"
                }
                alt="divider"
                width="100%"
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <h3 className="event_title">
                NEW WINTER OUTFITS
                <img
                  src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/royale_logo.png"
                  width="50"
                  alt="royale"
                />
                <img
                  src="https://cdn.battlerite.com/www3/images/static/logos/logo-small.png"
                  width="33"
                  alt="arena"
                />
              </h3>
              <img
                className="outfit_lineup"
                src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/winter_outfit_lineup2.png"
                alt="winter_outfits"
                style={{ width: "100%" }}
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <ImageText
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/Ruhkaan_winter_outfit_lore.png"
                title="Winter's Greed Ruh Kaan"
                orientation="rightleft"
                description="Those who fail to keep their hearts warm with the compassion of Yuletide, but rather let it turn cold with greed and selfishness. Those that hide food and firewood rather than share, or demand gifts while giving nothing back. They will wake in the deep of the night to a hooded spectre with crooked horns and icy eyes standing over them. It is Winter's Greed who, drawn to their cold hearts, has come to steal them away never to be seen again."
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <ImageText
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/Bakko_winter_outfit_lore.png"
                title="Frost Father Bakko"
                orientation="leftright"
                description={
                  <>
                    <p>
                      It's said that every year the Frost Father travels down
                      from the Frozen North with snow and cold winds following
                      in his wake. The sight of a white-bearded man with antlers
                      covered in gleaming hoarfrost is a sure sign that winter
                      is approaching.
                    </p>
                    <p style={{ marginTop: "10px" }}>
                      But more than a harbinger of winter, the Frost Father also
                      personifies the warmth and mirth that keeps the bitter
                      cold at bay. The only way to overcome this harsh season is
                      to come together and share the scarce resources, so
                      friends and kin gather to escape the cold and to share
                      gifts, tales, food and company. For just as important as
                      it is to keep the fire burning in the hearth, is it to
                      keep the warmth in one's heart.
                    </p>
                  </>
                }
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <ImageText
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/Alysia_winter_outfit_lore.png"
                title="Lightbringer Alysia"
                orientation="rightleft"
                description="When the northern tribes gather around the fire pit to escape the bitter midwinter nights, they tell the legend of the Lightbringer - a being of otherworldly beauty who seems to float through the black night, her crown of candles burning untouched by winds and snow. She who brings a spark of light and warmth when the winter is at its harshest."
              />
              <img
                draggable={false}
                src={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/Line%20divider.png"
                }
                alt="divider"
                width="100%"
                style={{ paddingTop: "10px" }}
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <Section
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/polucie.png"
                style={{ width: "100%" }}
              >
                <div className="poloma-content">
                  <h3>
                    POLOMA & LUCIE ARRIVE ON TALON ISLAND
                    <img
                      src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/royale_logo.png"
                      width="50"
                      alt="royale"
                    />
                  </h3>
                </div>
              </Section>
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <Section
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/section3_background_fix2.png"
                }
                style={{ width: "100%" }}
              >
                <ChampionDescription
                  image={
                    "https://cdn.battlerite.com/www3/images/champion-images/poloma.png"
                  }
                  title="Poloma"
                  text="A psychopomp from the deep forests of Silverridge, Poloma uses shamanic powers to guide life and spirits alongside her protector and loyal creature, Toki. A dark disturbance among souls has put Poloma on a new path, leaving her safety and home behind. Driven by her burning curiosity and extraordinary senses, Poloma now seeks her answers in the arena."
                />
              </Section>
            </LazyLoad>

            <LazyLoad height={400} offset={400}>
              <AbilitySpread
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/abilitiesBackground2-min.png"
                }
                champion="poloma"
                abilities={abilities["poloma"][this.state["poloma"]]}
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <Section
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/section3_background_fix2.png"
                }
                style={{ width: "100%" }}
              >
                <ChampionDescription
                  image={
                    "https://cdn.battlerite.com/www3/images/champion-images/lucie.png"
                  }
                  title="Lucie"
                  text="Lucie is a highly skilled Alchemist. A rebel at school who got expelled from the Toleen Academy for mixing banned potions. She is a diverse contender who knows which brew makes you choke, heal or flee in fear. The arena has become her new playground for wild experiments. Seeing her smile while mixing ingredients of an unknown nature might make her look more crazy than cute."
                />
              </Section>
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <AbilitySpread
                image={
                  "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/abilitiesBackground2-min.png"
                }
                champion="lucie"
                abilities={abilities["lucie"][this.state["lucie"]]}
              />
            </LazyLoad>
            <LazyLoad height={400} offset={400}>
              <Section
                image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/sectionDivider_emotes-min.png"
                style={{
                  width: "100%",
                  height: "100%",
                  opacity: "1"
                }}
                imageStyle={{
                  minHeight: "580px"
                }}
              >
                <div className="emoteBlock">
                  <div className="emoteBlock-text">
                    <h3>
                      NEW EMOTE SYSTEM
                      <img
                        src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/royale_logo.png"
                        width="50"
                        alt="royale"
                      />
                      <img
                        src="https://cdn.battlerite.com/www3/images/static/logos/logo-small.png"
                        width="33"
                        alt="arena"
                      />
                    </h3>
                    <p>
                      Express yourself in style with emotes, the first of which
                      arrive with the Yuletide.
                    </p>
                    <p>And there was much rejoicing!</p>
                  </div>
                  <div className="emoteBlock-images">
                    <img
                      alt="emote"
                      src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/jadeclap-min.gif"
                    />
                    <img
                      alt="emote"
                      src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/bakkobow-min.gif"
                    />
                    <img
                      alt="emote"
                      src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/raigonsalute-min.gif"
                    />
                  </div>
                </div>
              </Section>
            </LazyLoad>
            <Section
              image="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/SEASON+5_c.png"
              style={{ width: "100%" }}
            >
              <div className="season">
                <img
                  src="https://cdn.battlerite.com/www3/images/static/logos/logo-small.png"
                  width="43"
                  alt="arena"
                />
                <p>
                  A new Season begins in Battlerite Arena! Progress with new and
                  returning Sponsors, with new rewards to earn!
                </p>
              </div>
            </Section>
          </div>
          <div className="footer">
            <Footer />
          </div>
        </div>
        <ModalVideo
          channel="youtube"
          isOpen={this.state.modalShown}
          videoId="IVrzgQnd8us"
          onClose={this.toggleModal}
        />
      </LoadingScreen>
    );
  }
}

export default App;
